import { createContext } from 'react';

// Define the context structure
interface AuthContextProps {
  isAuthenticated: boolean;
}

// Create the AuthContext
export const AuthContext = createContext<AuthContextProps | null>(null);
